<template>
  <div class="v-view grid-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>

    <div class="gv-wrapper">
      <div class="gv-item" v-for="(item, index) in dataList" :key="index">
        <div class="gv-item-value">
          <span>{{ item.value }}</span>
          <span>{{ item.unit }}</span>
        </div>
        <div class="gv-item-label">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ServiceResorce',
  computed: {
    ...mapGetters(['cid'])
  },
  props: {
    span: {
      type: Number,
      default: 1
    },
    title: {
      type: String,
      default: '养老资源统计'
    }
  },
  data() {
    return {
      dataList: [
        {
          name: '老人总数',
          value: 10.9,
          unit: '万人'
        },
        {
          name: '服务组织',
          value: 674,
          unit: '家'
        },
        {
          name: '服务人员',
          value: 981,
          unit: '人'
        },
        {
          name: '5A级机构',
          value: 130,
          unit: '家'
        },
        {
          name: '4A级机构',
          value: 319,
          unit: '家'
        },
        {
          name: '3A级机构',
          value: 225,
          unit: '家'
        }
      ]
    }
  },
  created() {
    this.getServiceResoureData()
  },
  methods: {
    getServiceResoureData() {}
  }
}
</script>

<style lang="scss" scoped>
.grid-view {
  .gv-wrapper {
    height: 100%;
    background: url('../assets/images/bg_resource.png') no-repeat center/80% 80%;
  }

  .gv-item {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 33.33%;
    height: 50%;

    &-value {
      font-size: 16px;
      color: #00a4f0;

      span:first-child {
        font-size: 34px;
      }
    }

    &-label {
      margin-top: 5px;
      font-size: 16px;
      color: #fa7310;
    }
  }
}
</style>
